<div class="row">
    <div class="col-10 attached-file-count">
        <span *ngIf="!files.length"> No files attached. </span>
        <span *ngIf="files.length == 1"> 1 file attached: </span>
        <span *ngIf="files.length > 1">
            {{ files.length }} files attached:
        </span>
    </div>
    <div class="col-2 text-end">
        <button
            (click)="addFile()"
            *ngIf="!disabled"
            class="btn btn-secondary file-upload-add-button"
            type="button"
        >
            Add
        </button>
    </div>
</div>
<div *ngIf="files.length" class="file-uploads-wrapper row">
    <div class="col">
        <div *ngFor="let file of files; let i = index" class="file-upload-div">
            <div *ngIf="!file.isSelected" class="row file-selection">
                <div class="col-10">
                    <input
                        (change)="fileChanged(file, $event)"
                        accept=".pdf,.bmp,.docx,.doc,.jpg,.jpeg,.png,.gif"
                        type="file"
                    />
                </div>

                <div class="col-2 text-end">
                    <a
                        (click)="cancelFile(file)"
                        class="cancel-link"
                        title="Cancel"
                    >
                        <span
                            [inlineSVG]="'close.svg'"
                            class="cancel-icon"
                        ></span>
                    </a>
                </div>
            </div>
            <div
                *ngIf="file.isSelected && !file.isUploaded && file.isUploading"
                class="file-uploading"
            >
                <span class="file-uploading-name"
                >Uploading {{ file.filename }}...</span
                >
            </div>
            <div
                *ngIf="file.isSelected && file.isUploaded && !file.isDeleting"
                class="row file-uploaded"
            >
                <div class="col-10">
                    <a
                        (click)="downloadFile(file)"
                        class="file-link"
                        target="_blank"
                    >
                        <div class="file-icon-or-thumb doNotPrint">
                            <img
                                *ngIf="isImageLink(file.blobStorageUrl)"
                                class="file-thumb"
                                src="{{ file.blobStorageUrl }}"
                            />
                            <span
                                *ngIf="!isImageLink(file.blobStorageUrl)"
                                [inlineSVG]="'document.svg'"
                                class="file-icon"
                            ></span>
                        </div>
                        {{ file.filename }}
                    </a>
                </div>
                <div class="col-2 text-end">
                    <a
                        (click)="deleteFile(file)"
                        *ngIf="!disabled"
                        class="trash-link file-upload-trash-link"
                        title="Delete"
                    >
                        <span
                            [inlineSVG]="'trash.svg'"
                            class="trash-icon"
                        ></span>
                    </a>
                </div>
            </div>
            <div *ngIf="file.isDeleting" class="file-deleting">
                Deleting {{ file.filename }}...
            </div>
            <div
                *ngIf="validationErrors?.['invalidFiles']?.[i]"
                class="file-validation-error text-danger mt-1"
            >
                {{ validationErrors?.["invalidFiles"]?.[i] }}
            </div>
        </div>
    </div>
</div>
